<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.unit.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.unit.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
       @input="pagination.page = $event"
             @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.unit.title')"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.unit.edit"
      :accessDelete="$access.unit.delete"
      :alert="form.alert"
    >
      <unitForm ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import unitServise from '@/services/unitService.js'
import unitForm from "../components/forms/units/unitForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { unitForm },

  data() {
    return {
      apiController: "unit",
      entityService: unitServise,
        searchFields: ["code", "description"],
      headers: [
        {
          text: this.$t("entities.unit.props.code"),
          align: "left",
          sortable: false,
          value: "code"
        },
        {
          text: this.$t("entities.unit.props.description"),
          align: "left",
          sortable: false,
          value: "description"
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right"
        }
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.unit.edit, this.$access.unit.show]
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.unit.delete
        }
      ]
    };
  },
  methods: {
    getModelDefault() {
      return {
        code: "",
        description: ""
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>